import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionConfigurationControlType,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';

export interface AiSummaryCardModel {
  meetingsHeldPast12Months: number;
  meetingsHeldTotal: number;
  notesSummary: string;
}

export class AiSummaryCardConfiguration extends ReportSectionConfigurationBase {
  typeName = 'AiSummaryCardConfiguration';
  nodataLocalizationKeyName = 'aiSummaryCard';
  readonly reportSection = ReportSection.AiSummaryCard;
  readonly applicableReportTypes = [ReportType.Institution, ReportType.InstitutionTemplate];
  readonly reportViewModelSections = [ReportViewModelSection.InvestorProfile_AiSummaryCard];

  minSize = 1;
  maxSize = 4;
  defaultSize = 4;
  availableDataSections: ReportSectionDataSection[] = [
    {
      name: 'meetingsHeldPast12Months',
      displayName: 'No. of Meetings Held in past 12 months',
      isSelected: true,
      canConfigure: false,
      unit: 6,
      property: 'meetingsHeldPast12Months',
      isStatic: true,
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'meetingsHeldTotal',
      displayName: 'Total Meetings Held',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'meetingsHeldTotal',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'notesSummary',
      displayName: 'Meeting Notes Summary',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'notesSummary',
      type: ReportSectionConfigurationControlType.Text
    }
  ];

  get name(): string {
    if (
      this.appliedReportType === ReportType.Institution ||
      this.appliedReportType === ReportType.InstitutionTemplate
    ) {
      return 'aiSummaryCard';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (
      this.appliedReportType === ReportType.Institution ||
      this.appliedReportType === ReportType.InstitutionTemplate
    ) {
      return 'AI Summary Card';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface AiSummaryDetailsData {
  [ReportViewModelSection.InvestorProfile_AiSummaryCard]: AiSummaryCardModel;
}
